import script from "./badge.vue?vue&type=script&lang=ts&setup=true"
export * from "./badge.vue?vue&type=script&lang=ts&setup=true"

import "./badge.vue?vue&type=style&index=0&id=89174d9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89174d9a"]])

export default __exports__